export const setDeviceData = payload => ({
	type: 'SET_DEVICE_DATA',
	payload
});

export const setSession = payload => ({
	type: "SET_SESSION",
	payload
});

export const showHideLoader = (payload) => {
    return {
        type: 'SHOW_HIDE_LOADER',
        payload
    };
}

export const setContractData = payload => ({
	type: "SET_CONTRACT_DATA",
	payload
});

export const setLoggedUser = payload => ({
	type: "SET_LOGGED_USER",
	payload
});

export const setObeLoggedUser = payload => ({
	type: "SET_OBE_LOGGED_USER",
	payload
});

export const setIsUserApprovedForCatCoverage = payload => ({
	type : "SET_APP_CAT_COV_USER",
	payload	
})